import React, { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';

const MobileDownload = () => {
    const [close, setClose] = useState(false);
    const location = useLocation();
    const basePath = 'activepark://';

    const closeClick = () => {
        setClose(false);
    };

    const stopPropagation = (e) => {
        e.stopPropagation();
    };

    useEffect(() => {
    const userAgent = navigator.userAgent;
    const isMobile = /iPhone|iPad|iPod/.test(userAgent) || /Android/.test(userAgent);
    const isStatistic = location.pathname.startsWith('/statistic');

    if (isMobile && !isStatistic) {
        setClose(true);
    } else {
        setClose(false);
    }
}, [location.pathname]);


    useEffect(() => {
        if (location.pathname.split('/')[1] === 'loginTest' && window.location.search) {
            moveFunc();
        }
    }, []);

    // Универсальная функция: deep link + fallback в Store
    const moveFunc = (storeLink) => {
        const appStoreLink = 'https://apps.apple.com/us/app/id1661291870';
        const playStoreLink = 'https://play.google.com/store/apps/details?id=com.technodreams.activeparks';
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
        const isAndroid = /Android/i.test(userAgent);

        let path;
        let id;

        switch (location.pathname.split('/')[1]) {
            case 'fc-events':
                if (['about', 'users'].includes(lastPart()) || lastPart().length < 8) {
                    id = partFromEnd(2);
                } else {
                    id = lastPart();
                }
                path = `${basePath}event/${id}`;
                break;
            case 'fc':
                if (['about', 'users'].includes(lastPart()) || lastPart().length < 8) {
                    id = partFromEnd(2);
                } else {
                    id = lastPart();
                }
                path = `${basePath}club/${id}`;
                break;
            case 'newspg':
                id = lastPart();
                path = `${basePath}news/${id}`;
                break;
            case 'parkInfo':
                id = lastPart();
                path = `${basePath}park/${id}`;
                break;
            case 'routeInfo':
                id = lastPart();
                path = `${basePath}routeActive/${id}`;
                break;
            case 'loginTest':
                let search = window.location.search.split('&');
                let code = search[0].slice(6);
                let state = search[1].slice(6);
                path = `${basePath}diia/${state}/${code}`;
                break;
            case 'pagenonauthorized':
                if (location.search.split('/')[1] === 'fc') {
                    id = location.search.split('/')[2];
                    path = `${basePath}club/${id}`;
                }
                if (location.search.split('/')[1] === 'fc-events') {
                    id = location.search.split('/')[2];
                    path = `${basePath}event/${id}`;
                }
                break;
            default:
                console.warn(`Unexpected pathname: ${location.pathname}`);
                path = `${basePath}main`;
        }

        const deepLink = path;

        // Десктоп — просто закрываем
        if (!isIOS && !isAndroid) {
            closeClick();
            return;
        }

        // Таймер на Store, если deep link не сработает
        const fallbackTimer = setTimeout(() => {
            if (storeLink) {
                window.location.href = storeLink;
            } else if (isIOS) {
                window.location.href = appStoreLink;
            } else if (isAndroid) {
                window.location.href = playStoreLink;
            }
        }, 1000);

        // Пробуем deep link
        window.location.href = deepLink;

        // Если deep link сработал — очищаем таймер
        window.addEventListener('blur', () => clearTimeout(fallbackTimer), { once: true });
    };

    // Хелперы для сокращения кода
    const lastPart = () => location.pathname.split('/').pop();
    const partFromEnd = (n) => location.pathname.split('/')[location.pathname.split('/').length - n];

    const openAppOrFallback = () => {
        moveFunc(); // теперь всё в ней
    };

    return (
        <>
            {close && 
            <div className="mobileMenu" onClick={closeClick}>
                <div className="mobileMenuFull" onClick={stopPropagation}>
                    <div className="mobileHeaderBlock">
                        <div className="mobileLogo" style={{background:`url(${'/images/LogoMob.png'})`}}></div>
                        <div>
                            <h2>Активні парки</h2>
                            <div className="mobileSpan">Додаток</div>
                        </div>
                        <button 
                            className='mobileCloseButton appClick' 
                            onClick={openAppOrFallback}
                        >
                            Відкрити
                        </button>
                        <div className="closeMobile" onClick={closeClick}>Х</div>
                    </div>
                </div>    
            </div>}
        </>
    );
};

export default MobileDownload;
